import { X } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Button } from './button';

type Props = {
  title: string;
  description: string;
  action?: React.ReactNode;
  progress?: React.ReactNode;
  className?: string;
  onClose?: () => void;
};

const ActivationBanner = ({ title, description, action, progress, className, onClose }: Props) => {
  return (
    <div
      className={cn(
        'group bg-secondary-foreground rounded-md border border-border flex flex-row flex-wrap sm:flex-nowrap items-center justify-between gap-4 px-5 py-4 relative',
        className,
      )}
    >
      {progress && <div className="group/progress shrink-0 flex items-center">{progress}</div>}
      <div className="group-[&:has(.group\/progress)]:w-[calc(100%-76px)] sm:group-[&:has(.group\/progress)]:w-auto sm:grow-1 text-white space-y-1">
        <h3 className="text-sm">{title}</h3>
        <p className="text-xs">{description}</p>
      </div>
      {action && (
        <div className="shrink-0 w-full sm:w-auto [&>*]:w-full group-[&:has(.group\/close-button)]:pr-3">{action}</div>
      )}
      {onClose && (
        <Button
          variant="ghost"
          size="icon"
          className="group/close-button size-7 text-white! hover:bg-transparent absolute top-0 right-0"
          onClick={onClose}
        >
          <X />
        </Button>
      )}
    </div>
  );
};

export { ActivationBanner };
